import { EstatusTarifa, Tarifa, TarifasQuery } from "src/gql/schema"

// Tarifas activas de tipo renta
export const filtrarTarifasRenta = (data?: TarifasQuery) =>
    (data?.tarifas
        .filter((t) => t.estatus === EstatusTarifa.Activa && !t.eliminado)
        .filter(({ tipo_tarifa = "" }) => tipo_tarifa.includes("renta")) || []) as Tarifa[]
